import { useNavigate } from 'react-router-dom';

import { OrangeButton } from 'components/Styled/v2/OrangeButton';

import { useTranslation } from 'react-i18next';

import './styles.scss';

const TravelExpertCTA = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/travel-expert');
  };

  return (
    <div className="travel-expert-cta">
      <div className="travel-expert-cta__content">
        <h2 className="travel-expert-cta__title">
          {t('home.travelExpertCTA.title')}{' '}
          <span className="travel-expert-cta__highlight">
            {t('home.travelExpertCTA.highlight')}
          </span>
        </h2>
        <p className="travel-expert-cta__subtitle">
          {t('home.travelExpertCTA.subtitle')}
          <br />a <strong>{t('home.travelExpertCTA.subtitleHighlight')}</strong>
        </p>
        <OrangeButton
          className="travel-expert-cta__button"
          type="link"
          onClick={handleClick}
        >
          {t('home.travelExpertCTA.button')}
        </OrangeButton>
      </div>
    </div>
  );
};

export default TravelExpertCTA;
